import Vue from 'vue'
import api from '../api/index'
import { isEmpty } from 'lodash'
import { Tag } from 'ecomntag/build/ecomnTag.min'
import SmartPointModel from '../../main/vue/SmartPoint/SmartPointModel'
import GoogleMapsService from '../../main/vue/googleMaps/googleMapsService'

export default {
  setOnlineStatus ({ commit }, data) {
    commit('setOnlineStatus', data)
  },
  setAllAttributes ({ state, commit }, data) {
    commit('setAllAttributes', data)
  },
  setProductBadges ({ commit }, data) {
    commit('setProductBadges', data)
  },
  setConfig ({ commit }, data) {
    commit('setConfig', data)
  },
  setSelectedProductCodeId ({ state, commit }, productCodeId) {
    const selected = state.products.find(item => {
      return item.productCodes.find(subItem => subItem.productCodeId === productCodeId)
    })
    if (selected) {
      commit('setSelectedProductCodeId', productCodeId)
    }
  },
  setSelectedAttributeId ({ state, commit }, attributeId) {
    commit('setSelectedAttributeId', attributeId)
  },
  setLiveProducts ({ commit }, products) {
    commit('setLiveProducts', products)
  },
  setLiveProductData ({ commit }, productData) {
    commit('setLiveProduct', productData)
  },
  setCartData ({ commit }, cartData) {
    if (cartData.hasOwnProperty('cartErrors')) {
      if (cartData.cartErrors.length === 0) {
        let successMessage = ''

        if (cartData.hasOwnProperty('addToCart')) {
          successMessage = Vue.locale.translate('cart.product_added')
        }

        if (cartData.hasOwnProperty('removeFromCart')) {
          successMessage = Vue.locale.translate('cart.product_removed')
        }

        if (successMessage !== '') {
          Vue.toasted.success(successMessage, {
            duration: 4000,
            icon: {
              name: 'check'
            }
          })
        }
      }

      // inform user based on errors
      if (cartData.cartErrors.hasOwnProperty('server')) {
        cartData.cartErrors.server.reduce((acc, item) => {
          Vue.toasted.error(item.msg, {
            duration: 10000,
            icon: {
              name: 'exclamation-triangle'
            },
            action: {
              text: Vue.locale.translate('close'),
              onClick: (e, toastObject) => {
                toastObject.goAway(0)
              }
            }
          })
          return acc
        }, [])
      }

      if (cartData.cartErrors.hasOwnProperty('validation')) {
        commit('setCartErrors', cartData.cartErrors.validation)
      }
    }

    if (cartData.hasOwnProperty('cartContents')) {
      commit('setCartProducts', cartData.cartContents)
    }

    if (cartData.hasOwnProperty('giftContents')) {
      commit('setCartGifts', cartData.giftContents)
    }

    if (cartData.hasOwnProperty('giftRules')) {
      commit('setCartGiftRules', cartData.giftRules)
    }

    if (cartData.hasOwnProperty('defaultCoupon')) {
      commit('setDefaultCoupon', cartData.defaultCoupon)
      commit('setCouponCode', cartData.defaultCoupon.couponCode)
      commit('setCouponDiscount', cartData.defaultCoupon.couponDiscount)
    }

    if (cartData.hasOwnProperty('liveData')) {
      for (const productData of cartData.liveData) {
        commit('setLiveProduct', productData)
      }
    }
  },
  addToCartClicked ({ dispatch, commit, getters }, payload) {
    const productData = getters.getSelectedProductByCodeId(payload.productCodeId)
    return api.addToCart(payload).then(response => {
      const tag = new Tag(window.dataLayer, {
        providerOptions: getters.config.tagManagerProviders,
        providerIdsPrefix: getters.config.trackingProductIdPrefix
      })
      if (payload.quantity === 0) {
        response.removeFromCart = true
        if (getters.config.tagManagerEnabled) {
          tag.removeFromCart({
            name: productData.productName,
            id: productData.productId,
            quantity: payload.quantity,
            price: productData.productFinalPrice
          })

          if (getters.config.tagManagerProviders.includes('googleGA4')) {
            tag.remove_from_cart_GA4({
              currency: getters.getSelectedCurrency.code,
              value: productData.productFinalPrice,
              items: [
                {
                  item_id: productData.productId,
                  item_name: productData.productName,
                  item_brand: productData.vendorName,
                  price: productData.productFinalPrice,
                  discount: productData.productOldPrice - productData.productFinalPrice
                }
              ]
            })
          }
        }
      } else {
        response.addToCart = true
        if (getters.config.tagManagerEnabled) {
          tag.addToCart({
            name: productData.productName,
            id: productData.productId,
            productCodeId: payload.productCodeId,
            quantity: payload.quantity,
            price: productData.productFinalPrice
          })

          if (getters.config.tagManagerProviders.includes('googleGA4')) {
            tag.add_to_cart_GA4({
              currency: getters.getSelectedCurrency.code,
              value: productData.productFinalPrice,
              items: [
                {
                  item_id: productData.productId,
                  item_name: productData.productName,
                  item_brand: productData.vendorName,
                  price: productData.productFinalPrice,
                  discount: productData.productOldPrice - productData.productFinalPrice
                }
              ]
            })
          }
        }
      }

      dispatch('setCartData', response)
    })
  },
  openProductCardModal ({ commit }, productId) {
    commit('openProductCardModal', productId)
  },
  closeProductCardModal ({ commit }) {
    commit('closeProductCardModal')
  },
  addGiftToSelection ({ commit }, { giftId, productId }) {
    commit('setGiftToSelectedGifts', { giftId: giftId, productId: productId, quantity: 1 })
  },
  removeGiftFromSelection ({ commit }, { giftId, productId }) {
    commit('removeGiftFromSelectedGifts', { giftId: giftId, productId: productId })
  },
  getTransporterData ({ commit }, payload) {
    api.getTransporterData(payload).then(response => {
      commit('setTransporters', response)
    })
  },
  setPreviewOrderData ({ commit }, payload) {
    commit('setPreviewOrderData', payload)
  },
  async checkCoupon ({ commit }, couponCode) {
    commit('setCouponDiscount', null)
    commit('setCouponCode', couponCode)
    const response = await api.checkCoupon(couponCode)
    commit('setCouponDiscount', response.discount)
  },
  setPreviewOrderTransporterId ({ commit }, transporterId) {
    commit('setTransporterId', transporterId)
  },
  popupMinicartGiftModal ({ commit }, payload) {
    commit('setMinicartGiftChoiceModal', payload)
  },
  setAllTransporterSmartPoints ({ commit, state, getters }, data) {
    commit('setAllTransporterSmartPoints', data)
    return false
  },
  smartPointUncheck ({ commit }) {
    const smartPointCheckbox = document.getElementById('smartPointChecked')
    if (smartPointCheckbox) {
      smartPointCheckbox.checked = false
    }
    commit('setSmartPointIsSelected', false)
    commit('setSelectedSmartPoint', new SmartPointModel())
  },
  setUriWithoutOffset ({ commit }, payload) {
    commit('setUriWithoutOffset', payload)
  },
  setIsTopLevelCategory ({ commit }, payload) {
    commit('setIsTopLevelCategory', payload)
  },
  setCurrentPageNumber ({ commit }, payload) {
    commit('setCurrentPageNumber', payload)
  },
  setProductCategoryData ({ commit }, payload) {
    commit('setProductCategoryData', payload)
  },
  setSearchInputSmartPoints ({ commit }, payload) {
    return commit('setSearchInputSmartPoints', payload)
  },
  setMaxResultsSmartPoints ({ commit }, payload) {
    commit('setMaxResultsSmartPoints', payload)
  },
  setClosestSmartPoints ({ commit }, payload) {
    return commit('setClosestSmartPoints', payload)
  },
  setCachedFilteredSearchedClosestSmartPoints ({ commit }, payload) {
    commit('setCachedFilteredSearchedClosestSmartPoints', payload)
  },
  setSelectedSmartPoint ({ commit }, payload) {
    return commit('setSelectedSmartPoint', payload)
  },
  smartPointMapCloseEvent ({ commit }, payload) {
    return commit('smartPointMapCloseEvent', payload)
  },
  smartPointMapOpenEvent ({ commit }, payload) {
    return commit('smartPointMapOpenEvent', payload)
  },
  addToCartComboClicked ({ commit }, payload) {
    commit('setAddToCartComboClicked', payload)
  },
  setGoogleMapLoading ({ commit }, payload) {
    return commit('setGoogleMapLoading', payload)
  },
  setMapPoints ({ commit }, payload) {
    commit('setMapPoints', payload)
  },
  async initializeGoogleService ({ commit, getters }, useClusters) {
    const selectedTransporterId = getters.getSelectedTransporterId
    const service = await new GoogleMapsService(getters.googleMapsApiKey, useClusters, selectedTransporterId)
    await commit('setGoogleService', service)

    await getters.googleService.createMap([])
    await getters.googleService.setCurrentUserLocation()

    return service
  },
  setCurrentUserGeolocation ({ commit }, payload) {
    return commit('setCurrentUserGeolocation', payload)
  },
  setCurrentUserGeolocationError ({ commit }, payload) {
    return commit('setCurrentUserGeolocationError', payload)
  },
  async smartPointClickEvent ({ dispatch, commit, getters }) {
    if (isEmpty(getters.googleService)) {
      await dispatch('initializeGoogleService', true)
    }
    await commit('setSmartPointIsSelected', true)

    if (getters.getCustomerPostalCode !== '' && getters.getCustomerPostalCode !== getters.getPreviousPostalCodeInput) {
      await dispatch('setSearchInputSmartPoints', getters.getCustomerPostalCode)
    }

    if (
      getters.getSearchInputSmartPoints === '' &&
      getters.getCachedFilteredSearchedClosestSmartPoints.length > 0 &&
      Number(getters.googleService.transporterId) === Number(getters.getSelectedTransporterId)
    ) { return }

    await getters.googleService.initMapPoints(getters.getSelectedTransporterSmartPoints)
    if (getters.getSearchInputSmartPoints !== '' && getters.getSearchInputSmartPoints !== getters.getPreviousPostalCodeInput) {
      await getters.googleService.findClosest(getters.getSearchInputSmartPoints, getters.getSelectedTransporterSmartPoints, getters.getMaxResultsSmartPoints)
    } else {
      await getters.googleService.findClosest(getters.getCurrentUserGeolocation, getters.getSelectedTransporterSmartPoints, getters.getMaxResultsSmartPoints)
    }
    getters.googleService.transporterId = Number(getters.getSelectedTransporterId)
  },
  setCheckoutLocalErrors ({ commit }, payload) {
    return commit('setCheckoutLocalErrors', payload)
  },
  validateVat ({ state, commit }, data) {
    clearTimeout(state.checkoutVatApiDebounceTimeout)
    const timeout = setTimeout(() => {
      commit('setVatError', false)
      commit('setEmptyVatData')
      if (data.vat) {
        api.validateVat(data).then(response => {
          commit('setVatError', !response.result.valid)
          if (response.result.valid) {
            commit('setVatData', response.result.data)
          }
        })
      }
    }, 800)
    commit('setCheckoutVatApiDebounceTimeout', timeout)
  },
  setSelectedCurrency ({ commit }, selectedCurrency) {
    commit('setSelectedCurrency', selectedCurrency)
  },
  setInitializedWidgetsForSmartPoints ({ commit }, payload) {
    commit('setInitializedWidgetsForSmartPoints', payload)
  }
}
